// fixme: needs more smart for address stuff
// fixme: needs to figure out something(tm) to do with location
export default {
    name: 'finnstream',
    dependencies: ['xhrservice', 'userservice', 'objectstore', 'loginservice'],
    callable(xhrservice, userservice, objectstore, loginservice) {
        const MAX_STREAM_GROUPS = 20;
        const STREAM_CACHE_TIME = 60 * 60 * 24 * 7;
        const LAST_MODIFIED_KEY = 'stream_last_modified';

        const identity = function(e) {
            return e;
        };

        const urls = {
            pub: '/stream/public.json',
            user: '/stream/user.json',
        };

        const formatters = {
            'curated-ad': formatCuratedAd,
            'new-ad-on-alert': formatNewAdOnAlert,
            'curated-search': formatCuratedSearch,
            'new-ad-on-follow-company': formatNewAdOnFollowCompany,
            'new-ad-on-follow-area': formatNewAdOnFollowArea,
            'popular-ads': formatPopularAds,
            'generic-content': formatGenericContent,
            'new-message-in-inbox': formatMessages,
            'relevant-ads': formatRelevantAds,
        };

        function fetch(url, query, headers) {
            const opts = {
                url,
                type: 'json',
                data: query || null,
                headers: headers || {},
            };

            return xhrservice
                .request(opts)
                .then(data => {
                    saveLastModified(data.lastModified);
                    return processStream(data);
                })
                .then(null, e => {
                    console.log('stream processing error', e, e.stack);
                    throw e;
                });
        }

        function processStream(data) {
            if (data && !data.displaySearchResults) {
                return [];
            } else {
                return formatStream(data.displaySearchResults);
            }
        }

        // Returns a new kind of stream that is more suitable for mustache etc. to deal with
        function formatStream(stream) {
            const newStream = stream.map(e => {
                if (!e) {
                    return null;
                } else if (formatters.hasOwnProperty(e.type)) {
                    return formatters[e.type](e);
                } else {
                    console.log('unhandled stream item type', e.type);
                    return null;
                }
            });

            return newStream.filter(identity);
        }

        // clones behaviour from
        // https://git.finn.no/projects/APPS/repos/android_finn_app/browse/finn_app/src/main/java/no/finn/android/util/DateUtils.java
        // Strings from
        // https://git.finn.no/projects/APPS/repos/android_finn_app/browse/finn_app/res/values/strings.xml
        function formatTime(isoTime) {
            const now = new Date();
            const then = new Date(isoTime);
            const deltaMins = (now - then) / 1000 / 60;
            const deltaHours = deltaMins / 60;

            if (deltaMins <= 1) {
                return 'Akkurat nå';
            } else if (deltaMins < 2) {
                return 'Ett minutt siden';
            } else if (deltaMins < 50) {
                return `${Math.round(deltaMins)} minutter siden`;
            } else if (deltaMins < 90) {
                return 'En time siden';
            } else if (deltaHours < 24) {
                return `${Math.round(deltaHours)} timer siden`;
            } else if (deltaHours < 48) {
                return 'I går';
            } else {
                return `${Math.round(deltaHours / 24)} dager siden`;
            }
        }

        function formatDateTimeString(isoTime) {
            const date = new Date(isoTime);
            return [
                date.getDate(),
                '.',
                date.getMonth() + 1,
                ' ',
                z(date.getHours()),
                `:${z(date.getMinutes())}`,
            ].join('');

            function z(d) {
                return d.toString().length === 1 ? `0${d}` : d;
            }
        }

        function formatPlace(item) {
            if (item.area && item.city && item.city !== item.area) {
                return `${item.city}, ${item.area}`;
            } else {
                return item.area || item.city || item.address || '';
            }
        }

        function formatPopularAds(item) {
            const title = 'Populært på FINN';
            const entry = makeAdGroup(item, item.title || title);
            if (!entry) {
                return null;
            }
            entry.isCatEnabled =
                item && item.actor && item.actor.id === 'finnkatten';
            return entry;
        }

        function formatGenericContent(item) {
            const entry = makeAdGroup(
                item,
                item && item.actor && item.actor.displayName
            );
            if (!entry) {
                return null;
            }
            entry.actorImage = item && item.actor && item.actor.imageUrl;
            entry.url = item && item.actor && item.actor.url;
            // FIXME: this is a quick fix. This should use another template,
            // or the template should be made more generic.
            entry.body = item && item.title;
            const attachments = item.attachments || [item.object];

            // eslint-disable-next-line no-cond-assign
            for (let i = 0, attachment; (attachment = attachments[i]); i++) {
                entry.adItems[i].title = attachment.displayName;
                entry.adItems[i].owner = attachment.content;
            }
            return entry;
        }

        function formatMessages(item) {
            const entry = {
                isMessageGroup: true,
                displayName: 'Du har en ny melding',
                published: formatTime(item.publishedISOFormat),
                publishedISO: item.publishedISOFormat,
                url: item.url,
                moreHitsUrl: item.url,
                hits: item.hits,
                hasMoreHits: false,
                messageItems: [],
            };
            if (item.attachments && item.attachments.length > 1) {
                entry.displayName = 'Du har nye meldinger';
                entry.hasMoreHits = item.hits > item.attachments.length;
                // eslint-disable-next-line no-cond-assign
                for (
                    let i = 0, attachment;
                    (attachment = item.attachments[i]);
                    i++
                ) {
                    entry.messageItems.push({
                        id: attachment.id,
                        senderName:
                            attachment.actor == null
                                ? ''
                                : attachment.actor.displayName,
                        subject: attachment.displayName,
                        content: attachment.content,
                        url: attachment.url,
                        publishedDateTimeString: formatDateTimeString(
                            attachment.publishedISOFormat
                        ),
                        published: formatTime(attachment.publishedISOFormat),
                        publishedISO: attachment.publishedISOFormat,
                    });
                }
            } else {
                entry.messageItems.push({
                    id: item.object.id,
                    senderName: item.actor.displayName,
                    subject: item.object.displayName,
                    content: item.object.content,
                    url: item.object.url,
                    publishedDateTimeString: formatDateTimeString(
                        item.object.publishedISOFormat
                    ),
                    published: formatTime(item.object.publishedISOFormat),
                    publishedISO: item.object.publishedISOFormat,
                });
            }

            return entry;
        }

        function formatCuratedAd(item) {
            let title = 'FINNs favoritter';
            if (item.actor && item.actor.displayName) {
                title = item.actor.displayName;
            }
            const entry = makeAdGroup(item, title);
            if (!entry) {
                return null;
            }
            entry.isCatEnabled =
                item && item.actor && item.actor.id === 'finnkatten';
            entry.body = item.displayName;
            return entry;
        }

        function formatNewAdOnAlert(item) {
            const subject = item.generator ? item.generator.displayName : '';
            return makeAdGroup(item, 'Nye treff i', subject);
        }

        function formatNewAdOnFollowCompany(item) {
            const subject = item.generator ? item.generator.displayName : '';
            const prefix =
                item.adTypeDef === 'job-full-time' ||
                item.adTypeDef === 'job-part-time'
                    ? 'Nye jobber'
                    : 'Nye annonser';
            return makeAdGroup(item, prefix, subject);
        }

        function formatNewAdOnFollowArea(item) {
            const subject = item.generator ? item.generator.displayName : '';
            return makeAdGroup(item, 'Nye treff i område', subject);
        }

        function formatCuratedSearch(item) {
            let title = 'FINNs favoritter';
            if (item.actor && item.actor.displayName) {
                title = item.actor.displayName;
            }
            const entry = makeAdGroup(item, title);
            if (!entry) {
                return null;
            }
            entry.isCatEnabled =
                item && item.actor && item.actor.id === 'finnkatten';
            entry.body = item.title;
            return entry;
        }

        function formatRelevantAds(item) {
            let title = 'FINN foreslår';
            if (item.displayName) {
                title = item.displayName;
            }
            const entry = makeAdGroup(item, title);
            if (!entry) {
                return null;
            }
            return entry;
        }

        function fixupImageUrl(url) {
            if (url) {
                return url.replace(/^http:/, 'https:');
            } else {
                return url;
            }
        }

        function formatAdItem(item) {
            const formatted = {
                id: item.id,
                url: item.url,
                imageUrl: fixupImageUrl(item.imageUrl),
                shortTitle: item.shortTitle || '',
                published: item.published,
                publishedISO: item.publishedISOFormat,
                title: item.title || item.shortTitle || '',
                price: item.price,
                hasNewPrice: !!item.previousPrice,
                place: formatPlace(item),
                owner: (item.actor && item.actor.displayName) || null,
                disallowImageCropping: item.disallowImageCropping,
                last: item.last,
                trackingCode: item.trackingCode,
            };
            return formatted;
        }

        // generic block for things like saved searches and new jobs from followed company.
        // heading is a title and url that goes to the search for example.
        // There can be one of more ad items attached
        function makeAdGroup(item, title, subject, body) {
            const entry = {
                id: item.id,
                type: item.type,
                isAdGroup: true,
                displayName: title || item.title || item.shortTitle || '',
                subject,
                body,
                published: formatTime(item.publishedISOFormat),
                publishedISO: item.publishedISOFormat,
                url: item.url,
                adItems: null,
                hits: item.hits,
                trackingCode: item.trackingCode,
            };

            let ads = item.attachments || [item.object];

            // occationally we've seen bad data, thus this paranoia
            ads = ads && ads.filter ? ads.filter(identity) : [];
            if (ads.length === 0) {
                return null;
            }

            if (item.hits && item.hits > ads.length) {
                entry.hasMoreHits = true;
            }

            entry.adItems = ads.map(formatAdItem);
            return entry;
        }

        function getSiteStreamCached() {
            if (loginservice.isLoggedIn()) {
                return cachingStreamFetcher('user_site_stream');
            } else {
                return cachingStreamFetcher('public_site_stream');
            }
        }

        function getSiteStream() {
            if (loginservice.isLoggedIn()) {
                return streamFetcher(
                    urls.user,
                    'user_site_stream',
                    STREAM_CACHE_TIME
                );
            } else {
                return streamFetcher(
                    urls.pub,
                    'public_site_stream',
                    STREAM_CACHE_TIME
                );
            }
        }

        function cachingStreamFetcher(cacheKey) {
            const cachedStream = objectstore.get(cacheKey) || [];
            const reducer = function(prev, curr) {
                if (curr.adItems) {
                    curr.adItems.forEach(item => {
                        if (item.id) {
                            prev.push(item.id);
                        }
                    });
                }
                return prev;
            };
            const cachedStreamIds = cachedStream.reduce(reducer, []);

            // Update fuzzy time
            cachedStream.forEach(item => {
                item.published = formatTime(item.publishedISO);
                if (item.isMessageGroup) {
                    item.messageItems.forEach(message => {
                        if (message.published) {
                            message.published = formatTime(
                                message.publishedISO
                            );
                        }
                    });
                }
            });

            userservice.addExcludedAdIds(cachedStreamIds);
            return Promise.resolve(cachedStream);
        }

        function streamFetcher(url, cacheKey, maxAge) {
            const query = getQuery();
            let headers = null;

            const lastModified = objectstore.get(LAST_MODIFIED_KEY);
            if (lastModified) {
                headers = {
                    'If-Modified-Since': lastModified,
                };
            }

            return fetch(url, query, headers).then(entries => {
                if (!entries) {
                    console.log('stream was empty');
                    return [];
                    // fixme: return something sensible/error handling
                }

                const cachedEntries = objectstore.get(cacheKey);
                if (cachedEntries) {
                    if (entries.length) {
                        entries = entries.concat(cachedEntries);
                        objectstore.put(
                            cacheKey,
                            entries.slice(0, MAX_STREAM_GROUPS),
                            maxAge
                        );
                    }

                    return entries;
                } else {
                    // Don't show lone banner if that's the only thing we get
                    if (entries.length === 1 && entries[0].isBanner) {
                        return [];
                    }

                    // TODO: shouldn't have to reposition here, but we currently get the wrong
                    // position from the stream service
                    objectstore.put(
                        cacheKey,
                        entries.slice(0, MAX_STREAM_GROUPS),
                        maxAge
                    );
                    return entries;
                }
            });
        }

        function getQuery() {
            const adIds = getVisitedAdIds();
            const excludedAdIds = getExcludeAdIds();
            const args = {};

            if (!adIds && !excludedAdIds) {
                return null;
            }

            if (adIds) {
                args.adids = adIds;
            }

            if (adIds && excludedAdIds) {
                args.excludeAdids = excludedAdIds;
            }

            return args;
        }

        function getVisitedAdIds() {
            const adIds = userservice.getVisitedAdIds();
            if (adIds && adIds.length) {
                return adIds;
            } else {
                return null;
            }
        }

        function getExcludeAdIds() {
            const adIds = userservice.getExcludedAdIds();
            if (adIds && adIds.length) {
                return adIds;
            } else {
                return null;
            }
        }

        function saveLastModified(lastModified) {
            if (lastModified == null) {
                return;
            }

            objectstore.put(LAST_MODIFIED_KEY, lastModified, STREAM_CACHE_TIME);
        }

        function clearLastModified() {
            objectstore.del(LAST_MODIFIED_KEY);
        }

        return {
            getSiteStream,
            getSiteStreamCached,
            formatStream,
            formatTime,
            clearLastModified,
        };
    },
};



// WEBPACK FOOTER //
// ./services/finnstreamservice.js